module.exports = __webpack_public_path__ + "static/media/water_truck_alt.dab5b855.svg";